export default __webpack_public_path__ + "static/media/somya-singh.7169d7d1.jpg";